import { Box, Icon } from "@outschool/backpack";
import { SearchFilters } from "@outschool/gql-backend-generated";
import { faFilter } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { Modal, ToggleButton } from "@outschool/ui-legacy-component-library";
import React, { useEffect, useState } from "react";

import CategoriesAgeFilter from "./CategoriesAgeFilter";
import { CategoryListingsFiltersMobileModal } from "./CategoryListingsFiltersMobileModal";
import { FiltersToShowType } from "./FiltersToShow";

type CategoryListingsFiltersMobileProps = {
  filters: SearchFilters;
  setFilters: (value: SearchFilters) => void;
  isCuratedCategoryFilter?: boolean;
  filtersToShow: FiltersToShowType;
};

export const CategoryListingsFiltersMobile = ({
  filters,
  setFilters,
  filtersToShow,
  isCuratedCategoryFilter = false,
}: CategoryListingsFiltersMobileProps) => {
  const { t } = useTranslation(
    "client\\components\\catagories\\CategoryListingsFiltersMobile",
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasAdditionalFilters = !!(
    filters.dow ||
    filters.endByTime ||
    filters.pricePerMeetingMax ||
    filters.pricePerMeetingMin ||
    filters.startAfter ||
    filters.startAfterTime ||
    filters.startBefore
  );

  // Controlling the modal visibility "Can't perform a React state update on an unmounted component" error. When filters change it means the user clicked on the "Apply" buttons. So whenever the final filter combination is applied (changed), it means the modal should be closed.
  useEffect(() => {
    setIsModalOpen(false);
  }, [filters]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        sx={{ padding: "20px 0 90px 0" }}
      >
        <CategoryListingsFiltersMobileModal
          filters={filters}
          onCancel={() => setIsModalOpen(false)}
          setFilters={setFilters}
          isCuratedCategoryFilter={isCuratedCategoryFilter}
          filtersToShow={{ ...filtersToShow, age: false }}
        />
      </Modal>

      <Box flex sx={{ width: "100%" }}>
        {filtersToShow.age && (
          <Box sx={{ width: "100%" }}>
            <CategoriesAgeFilter
              // @ts-ignore TS(2322): Type 'InputMaybe<string> | undefined' is not assig... Remove this comment to see the full error message
              searchFiltersAge={filters.age}
              setSearchFiltersAge={age => {
                setFilters({ ...filters, age: age });
              }}
            />
          </Box>
        )}
        <ToggleButton
          sx={{
            padding: "1.1rem",
            border: "1px solid rgba(92, 111, 139, 0.4)",
            backgroundColor: hasAdditionalFilters ? "peacock300" : "#FFF",
            color: hasAdditionalFilters ? "#FFF" : "#000",
            "&:hover": {
              cursor: "pointer",
              backgroundColor: hasAdditionalFilters ? "#FFF" : "#primary",
              color: hasAdditionalFilters ? "#000" : "#FFF",
            },
            fontWeight: "normal",
          }}
          onClick={() => setIsModalOpen(true)}
        >
          <Icon
            sx={{
              marginRight: "5px",
            }}
            icon={faFilter}
          />
          {t("Filter")}
        </ToggleButton>
      </Box>
    </>
  );
};
